import { useTranslation } from 'react-i18next';
import { faSave } from '@fortawesome/pro-light-svg-icons';
import ActionButton from 'components/ui/ActionButton';
import styled from 'styled-components';

type SaveChangesButtonProps = {
    disabled?: boolean;
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    title: string;
    label?: string;
    isLoading?: boolean;
};

const SaveChangesButton: React.FC<SaveChangesButtonProps> = ({ disabled, onClick, title, label, isLoading }) => {
    const { t } = useTranslation();
    return (
        <SecondaryBtn
            label={label ?? t('saveChanges', 'Save changes')}
            onClick={onClick}
            disabled={disabled}
            isLoading={isLoading}
            icon={faSave}
            fullWidth
            title={title}
            main
            rounded
        />
    );
};

export default SaveChangesButton;

const SecondaryBtn = styled(ActionButton)`
    display: flex;
    align-items: center;
    gap: 9px;
    width: 100%;
    padding: 1rem;
    border: none;
    cursor: pointer;
    text-align: left;
    font-family: inherit;

    &:disabled {
        cursor: text;
    }

    &:not(:disabled):hover {
        opacity: 0.7;
    }
`;
